import MessageBus from '@mtt/postal-kit';

if (process.env.REACT_APP_MULTI_THREADED === 'true') {
  const worker = new Worker('./backend', { type: 'module', name: 'logic' });
  MessageBus.instanceId('frontend');
  MessageBus.fedx.signalReady(
    {
      xframe: [{ target: worker }],
    },
    () => {}
  );
} else {
  // eslint-disable-next-line global-require
  require('./backend');
}

export const start = () => {
  MessageBus.publish({ topic: 'wh.mtt.command.logic.start' });
};
export const stop = () => {
  MessageBus.publish({ topic: 'wh.mtt.command.logic.stop' });
};
export const send = event => {
  MessageBus.publish({ topic: 'wh.mtt.command.logic.send', data: event });
};
